/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Delivery API
 * This API manages the projects and docuements that are stored in the Ameta Document Delivery. The API used oAuth2 flow for authorization.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeoJSONLocationGeometry
 */
export interface GeoJSONLocationGeometry {
    /**
     * 
     * @type {string}
     * @memberof GeoJSONLocationGeometry
     */
    type: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeoJSONLocationGeometry
     */
    coordinates: Array<string>;
}

export function GeoJSONLocationGeometryFromJSON(json: any): GeoJSONLocationGeometry {
    return GeoJSONLocationGeometryFromJSONTyped(json, false);
}

export function GeoJSONLocationGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJSONLocationGeometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function GeoJSONLocationGeometryToJSON(value?: GeoJSONLocationGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
    };
}


